import { createClient } from '@supabase/supabase-js';

/**
 * `VITE_SUPABASE_ANON_KEY` is meant to ship to browsers — it can only do what
 * Row Level Security allows, unlike the service_role key the API uses. See
 * docs/overhaul/TODO-USER.md item 5.
 *
 * `storage: sessionStorage` (not the default localStorage) keeps the same
 * property the previous JWT-in-sessionStorage scheme had on purpose: the
 * session is scoped to the tab and gone when the browser closes, so a shared
 * workshop PC doesn't keep a working admin session indefinitely.
 */
export const supabase = createClient(
  import.meta.env.VITE_SUPABASE_URL,
  import.meta.env.VITE_SUPABASE_ANON_KEY,
  { auth: { storage: sessionStorage, autoRefreshToken: true, persistSession: true } }
);
